<li class="spectrum-Menu-divider" role="separator" />
